import { render, staticRenderFns } from "./team_ord_detail_GY.vue?vue&type=template&id=ffcc22c0&scoped=true&"
import script from "./team_ord_detail_GY.vue?vue&type=script&lang=js&"
export * from "./team_ord_detail_GY.vue?vue&type=script&lang=js&"
import style0 from "./team_ord_detail_GY.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./team_ord_detail_GY.vue?vue&type=style&index=1&id=ffcc22c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcc22c0",
  null
  
)

export default component.exports